import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

interface IProps {
  label?: string;
  value?: string;
  containerSx?: SxProps<Theme>;
  labelSx?: SxProps<Theme>;
  valueSx?: SxProps<Theme>;
}

const LabelValueItem = ({
  label,
  value,
  containerSx = {},
  valueSx = {},
  labelSx = {},
}: IProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', ...containerSx }}>
      <Typography sx={{ fontWeight: 'bold', ...labelSx }}>{label}</Typography>
      <Typography sx={{ fontSize: '18px', lineHeight: '22px', ...valueSx }}>
        {value}
      </Typography>
    </Box>
  );
};

export default LabelValueItem;
